<template>
  <div class="modal micromodal-slide change_data" v-bind:class="{ 'is-open': this.open }">
    <!-- <div class="bg" v-bind:class="{'open': this.open}"></div> -->
    <div class="modal__overlay" v-on:click="close()"></div>
    <div class="modal_item">
      <div class="detail_wrap">
        <button v-on:click="close()" class="close"><span class="close_image"><img src="../../assets/images/close.png" alt=""></span></button>
        <h2 class="content_title">登録クレジットカード</h2>
        <div v-if="cardList.length != 0" class="scroll mt24" ref="modal__content">
          <div v-for="(item, n) in cardList" class="credit_item right_arrow bdb pl16 pr20 pb10" v-bind:class="{ 'pt11': n != 0 }">
            <input v-bind:id="'credit' + n" class="payment_radio" type="radio" name="credit" v-bind:checked="checkedItem == item.creditCardId">
            <!-- defChecked(n) -->
            <label v-bind:for="'credit' + n" class="payment_contents credit_contents rb" v-on:click="changeCredit(item.creditCardId)">
              <span class="credit_image"><img v-bind:src="require('../../assets/images/credit/' + item.cardBrand + '.png')" alt=""></span>
              <span class="credit_number ar">
                {{ item.cardNo }}
                <CreditcardExpired :expired="item.expired" :expireYearMonth="item.expireYearMonth" />
                <!-- <div class="credit_info rr">有効期限 <span class="expired_date rr">{{ item.expireYearMonth }}</span> <span v-if="item.expired" class="expired">有効期限切れ</span></div> -->
              </span>

            </label>
          </div>
          <div v-if="subscriptionNowBC != '001' && pageName == 'subscription'" class="credit_item right_arrow bdb pl16 pr25 pb10 pt11">
            <input id="sameCredit" class="payment_radio" type="radio" name="credit" v-bind:checked="checkedItem == 0">
            <label for="sameCredit" class="payment_contents credit_contents rb" v-on:click="changeCredit(0)">
              <span class="same_credit rm">BC001と同じクレジットカードに設定する</span>
            </label>
          </div>
        </div>
        <div v-else class="pt19 pl16 pr20 pb10">クレジットカードが登録されていません</div>
      </div>
      <div class="btn_wrap">
        <button v-if="cardList.length != 0" v-on:click="send()" class="btn_yellow">このカードを使う</button>
        <a href="#" class="btn_blue" @click.stop.prevent="addCard()">クレジットカードを追加</a>
        <!-- <div class="" v-if="pageName == 'purchase'">
          <router-link class="btn_blue" :to="{ name: 'AddCreditCard', query: {redirect_url: 'purchaseSelectPaymentAndShipping'} }">クレジットカードを追加</router-link>
        </div> -->
        <!-- <div v-else class="">
          <router-link class="btn_blue" :to="{ name: 'AddCreditCard', query: {redirect_url: 'repeatSelectPaymentAndShipping'} }">クレジットカードを追加</router-link>
        </div> -->
      </div>

    </div>
    <!-- {{ selectCredit }} -->
  </div>
</template>

<script>
import creditCard from '@/components/api/creditCard'
import scrollPosition from '@/model/scrollPosition';
import { mapGetters } from 'vuex';
import CreditcardExpired from '@/components/common/CreditcardExpired.vue';

export default {
  props: ['pageName'],
  components: {
    CreditcardExpired
  },
  data() {
    return {
      selectNumber: 0,
      open: false,
      cardList: [],
      sameWithBc: false,
      checkedItem: null,
      deliveryCreditCardId: null,
    }
  },
  methods: {
    addCard() {
      let redirect_url = '';
      if(this.pageName == 'purchase') {
        redirect_url = 'purchaseSelectPaymentAndShipping';
      } else {
        redirect_url = 'repeatSelectPaymentAndShipping';
      }
      localStorage.setItem('userDetail', JSON.stringify(this.userDetail));
      // reloadCheckをfalseにする
      this.$store.commit('setAddCreditCardReloadCheck', true);
      localStorage.setItem('reloadCheck', true);
      this.$router.push({ name: 'AddCreditCard', query: {redirect_url: redirect_url, reload_param: Math.random().toString(32).substring(2)} });
    },
    defChecked(itemNumber) {
      // 選択前に表示されているものにcheckedをつける
      if(this.selectNumber == itemNumber) {
        return true;
      }else {
        return false;
      }
    },
    changeCredit(creditCardId) {
      this.checkedItem = creditCardId;
      this.deliveryCreditCardId = creditCardId;
      if(creditCardId == 0) {
        this.sameWithBc = true;
      } else {
        this.sameWithBc = false;
      }
    },
    close() {
      // this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
      this.open = false;
    },
    refsOpen() {
      // 親要素からmethods実行
      this.open = true;
    },
    send() {
      this.$store.commit('setSubscriptionViewSameWithBc001', this.sameWithBc);
      // this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
      if(this.pageName == 'subscription') {
        this.apiUpdateCreditCard();
      }

      let findItem = this.cardList.findIndex((value) => value.creditCardId == this.deliveryCreditCardId);
      // console.log(findItem);
      // console.log(this.creditCardId);
      if(this.sameWithBc) {
        findItem = this.cardList.findIndex((value) => value.sameWithBc001 == true);
        // this.cardList[findItem].message = '※BC001のクレジットカード情報を使用します。';
        // this.$emit('selectData', this.cardList[findItem]);
      }
      //  else {
      //   // this.cardList[this.selectNumber].message = '';
      //   this.$emit('selectData', this.cardList[this.selectNumber]);
      //   this.apiUpdateCreditCard();
      // }
      if(findItem == -1) {
        let data = {
          cardBrand: '',
          cardNo: '✴︎✴︎✴︎✴︎✴︎✴︎',
          creditCardId: 0,
          expireYearMonth: '',
          expired: '',
          holderName: '',
          selected: true,
          sameWithBc001: true,
        }

        // store使う時用
        // let data = {
        //   cardBrand: this.subscriptionSameWithBc001CardBrand,
        //   cardNo: this.subscriptionSameWithBc001CardNo,
        //   creditCardId: this.subscriptionSameWithBc001CreditCardId,
        //   expireYearMonth: this.subscriptionSameWithBc001ExpireYearMonth,
        //   expired: this.subscriptionSameWithBc001Expired,
        //   holderName: this.subscriptionSameWithBc001HolderName,
        //   selected: this.subscriptionSameWithBc001Selected,
        //   sameWithBc001: this.subscriptionSameWithBc001SameWithBc001,
        // }

        this.storeActionsCreditData(
          data.cardBrand,
          data.cardNo,
          data.creditCardId,
          data.expireYearMonth,
          data.expired,
          data.holderName,
          data.selected,
          data.sameWithBc001
        );
        this.$emit('selectData', data);
      } else {
        this.storeActionsCreditData(
          this.cardList[findItem].cardBrand,
          this.cardList[findItem].cardNo,
          this.cardList[findItem].creditCardId,
          this.cardList[findItem].expireYearMonth,
          this.cardList[findItem].expired,
          this.cardList[findItem].holderName,
          this.cardList[findItem].selected,
          this.cardList[findItem].sameWithBc001
        );
        this.$emit('selectData', this.cardList[findItem]);
      }



      this.open = false;
    },
    storeActionsCreditData(cardBrand, cardNo, creditCardId, expireYearMonth, expired, holderName, selected, sameWithBc001) {
      this.$store.dispatch('commitUserDetailCreditData', {
        cardBrand: cardBrand,
        cardNo: cardNo,
        creditCardId: creditCardId,
        expireYearMonth: expireYearMonth,
        expired: expired,
        holderName: holderName,
        selected: selected,
        sameWithBc001: sameWithBc001,
      });
    },
    defaultCreditCardData(data) {
      for (var i = 0; i < data.length; i++) {
        if(data[i].selected && data[i].sameWithBc001) {
          // this.selectNumber = -1;
          this.deliveryCreditCardId = 0;
          this.checkedItem = 0;

          this.$store.commit('setSubscriptionSameWithBc001CreditCardId', data[i].creditCardId);
          this.$store.commit('setSubscriptionSameWithBc001CardBrand', data[i].cardBrand);
          this.$store.commit('setSubscriptionSameWithBc001CardNo', data[i].cardNo);
          this.$store.commit('setSubscriptionSameWithBc001ExpireYearMonth', data[i].expireYearMonth);
          this.$store.commit('setSubscriptionSameWithBc001Expired', data[i].expired);
          this.$store.commit('setSubscriptionSameWithBc001HolderName', data[i].holderName);
          this.$store.commit('setSubscriptionSameWithBc001Selected', data[i].selected);
          this.$store.commit('setSubscriptionSameWithBc001SameWithBc001', data[i].sameWithBc001);

          this.$store.commit('setSubscriptionViewSameWithBc001', true);

          this.storeActionsCreditData(
            data[i].cardBrand,
            data[i].cardNo,
            data[i].creditCardId,
            data[i].expireYearMonth,
            data[i].expired,
            data[i].holderName,
            data[i].selected,
            data[i].sameWithBc001
          );


          this.$emit('selectData', data[i]);
          return false;
        } else if (data[i].selected) {
          // this.selectNumber = i;
          this.deliveryCreditCardId = data[i].creditCardId;
          this.checkedItem = data[i].creditCardId;
          this.$emit('selectData', data[i]);
          this.storeActionsCreditData(
            data[i].cardBrand,
            data[i].cardNo,
            data[i].creditCardId,
            data[i].expireYearMonth,
            data[i].expired, data[i].holderName,
            data[i].selected,
            data[i].sameWithBc001
          );
          return false;
        }
      }
    },
    async apiGetCreditCardList() {
      let bc;
      if(this.pageName == 'subscription') {
        bc = localStorage.getItem('subNowBC');
      } else if(this.pageName == 'purchase') {
        bc = localStorage.getItem('nowBC');
      }
      await creditCard.getCreditCardList(bc).then((val) => {

        console.log(val);
        if(val) {
          this.cardList.push(...val.creditCardList);
          let userDetail = JSON.parse(localStorage.getItem('userDetail'));
          if(userDetail) {
            let findItem = this.cardList.findIndex((value) => value.creditCardId == userDetail.selectCreditData.creditCardId);
            console.log(findItem);
            if(findItem != -1) {
              if(userDetail.selectCreditData.sameWithBc001) {
                this.deliveryCreditCardId = 0;
                this.checkedItem = 0;
              } else {
                this.deliveryCreditCardId = userDetail.selectCreditData.creditCardId;
                this.checkedItem = userDetail.selectCreditData.creditCardId;
              }

              this.$emit('selectData', this.cardList[findItem]);
            } else {
              this.defaultCreditCardData(val.creditCardList);
            }
            (findItem != -1) ? this.selectNumber = findItem : this.defaultCreditCardData(val.creditCardList);
            // this.$emit('selectData', this.cardList[this.selectNumber]);

          } else {
            this.defaultCreditCardData(val.creditCardList);
          }
// this.defaultCreditCardData(val.creditCardList);
        }
      });
    },
    async apiUpdateCreditCard() {
      let bc = localStorage.getItem('subNowBC');
      await creditCard.updateCreditCard(bc, this.deliveryCreditCardId, this.sameWithBc).then((val) => {
        console.log(val);
      });
    }
  },
  computed: mapGetters([
    'subscriptionNowBC',
    'subscriptionSameWithBc001CreditCardId',
    'subscriptionSameWithBc001CardBrand',
    'subscriptionSameWithBc001CardNo',
    'subscriptionSameWithBc001ExpireYearMonth',
    'subscriptionSameWithBc001Expired',
    'subscriptionSameWithBc001HolderName',
    'subscriptionSameWithBc001Selected',
    'subscriptionSameWithBc001SameWithBc001',
    'userDetail',
  ]),
  created() {
    if(this.$route.query.status == 'addCreditCard') {
      this.open = true;
    }
    this.apiGetCreditCardList();
  }
}
</script>

<style lang="css" scoped>
.same_credit {
  font-size: 14px;
}
.modal_item {
  /* overflow: scroll; */
  padding-bottom: 100px;
}
.modal_item .scroll {
  max-height: 150px;
  padding-bottom: 40px;
  /* padding-bottom: 100px; */
}
.content_title {
  letter-spacing: 3px;
  width: 205px;
}

.credit_contents {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
}
.credit_info {
  font-size: 10px;
  width: 100%;
}
.expired {
  color: #FF0000;
  font-size: 10px;
}
.expired_date {
  font-size: 12px;
}

.credit_image {
  max-width: 34px;
}

.credit_number {
  letter-spacing: .5px;
  margin-left: 4px;
}
.btn_blue {
  margin-top: 26px;
}
.btn_yellow {
  margin-top: 20px;
}

/* 消したいけど消すとチェックされた時に青丸が出てこない */
.payment_contents {
  cursor: pointer;
  padding-left: 28px;
  position: relative;
  width: 100%;
}

.payment_contents::before,
.payment_contents::after {
  bottom: 0;
  border-radius: 100px;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
}
.payment_contents::before {
  background: #F5F5F5;
  border: 1px solid #AAAAAA;
  height: 20px;
  left: 0;
  width: 20px;
}

.payment_contents .credit_image {
  opacity: .4;
}

.payment_radio:checked + .payment_contents .credit_image {
  opacity: 1;
}

.payment_radio:checked + .payment_contents::after {
  background: #00C2FF;
  height: 12px;
  left: 5px;
  width: 12px;
}

.payment_radio {
  display: none;
}
/* ここまで */
.card_wrap {
  max-height: 150px;
  overflow-y: scroll;
}

.btn_wrap {
  padding-bottom: 40px;
}

.item_detail.open {
  height: 85%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SelectCredit.vue